import React, { useRef, useState, useEffect } from 'react';

const ColorPicker = ({ label, value, onChange }) => {
  const colorInputRef = useRef(null);
  const [pickerValue, setPickerValue] = useState(value);

  useEffect(() => {
    // Create a temporary element to resolve the color
    const temp = document.createElement('div');
    temp.style.color = value;
    document.body.appendChild(temp);

    // Get the computed color in rgb format
    const computedColor = window.getComputedStyle(temp).color;
    document.body.removeChild(temp);

    // Convert rgb to hex for the color input
    const rgb = computedColor.match(/\d+/g);
    if (rgb) {
      const hex = '#' + rgb.map(c => parseInt(c).toString(16).padStart(2, '0')).join('');
      setPickerValue(hex);
    }
  }, [value]);

  const handleSwatchClick = () => {
    colorInputRef.current.click();
  };

  return (
    <div className="widget-color-wrap">
      <label className="text-sm">{label}</label>
      <div className="flex items-center gap-2">
        <input
          type="text"
          className="w-24 rounded-[10px] border border-gray-200 p-2 text-sm"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <div
          className="h-8 w-8 cursor-pointer rounded-[5px] border border-gray-200"
          style={{ backgroundColor: value }}
          onClick={handleSwatchClick}
        />
        <input
          type="color"
          ref={colorInputRef}
          value={pickerValue}
          onChange={(e) => onChange(e.target.value)}
          className="absolute invisible"
        />
      </div>
    </div>
  );
};

export default ColorPicker;
